import type { PluralOverrides, StringOverrides } from '../index';

/**
 * Swiss standard German: written German as used in Switzerland, not the spoken dialect
 * (which has no agreed spelling). The consistent rule is that "ß" is always written "ss";
 * everything else is inherited from German so the two cannot drift apart.
 *
 * Every phrase containing "ß" is repeated here with "ss"; everything else is inherited.
 */
export const strings: StringOverrides = {
  'action.close': 'Schliessen',
  'viewer.escCloses': 'Esc schliesst diese Ansicht.',
  'settings.textSize': 'Schriftgrösse',
  'settings.optionLarge': 'Gross',
  'menu.closeMenu': 'Menü schliessen',
};

export const plurals: PluralOverrides = {};
